import React, { Fragment, Suspense } from 'react';
import { connect } from 'react-redux';
import UserHelper from 'infrastructure/UserHelper';
import { serviceLocator } from 'infrastructure/ServiceLocator';
import { removeUser, addUser } from 'actions/actions';
import { push } from 'react-router-redux';
import routes from 'library/Routes';
import Header from 'components/Header/Header';
import Footer from 'layouts/CoreLayout/Footer';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import LayoutHelper from './LayoutHelper';
import ErrorBoundary from '../components/ErrorBoundary';
import {DomainState, User} from "../types";


interface AppState {
  user: User | undefined;
  locale: any;
  domain: DomainState;
}

interface OwnProps {
  location?: {
    pathname: string;
    search: string;
  };
}

interface StateProps {
  user: User | undefined;
  t: (key: string, params?: any) => string;
  domain: DomainState;
  currentLanguage: string;
}

interface DispatchProps {
  addUser: (user: User) => void;
  logOff: (location?: { pathname: string; search: string }) => void;
}

type WithClientAuthorizationProps = OwnProps & StateProps & DispatchProps;

interface WithClientAuthorizationState {
  allowed: boolean;
}

export const ClientAuthorization = (
  WrappedComponent: React.ComponentType<any>,
  allowedRoles: string[],
  showPricing?: boolean,
  hideFooter?: boolean,
  hideHeader?: boolean,
  redirectLogin?: string
) => {
  class WithClientAuthorization extends React.Component<
    WithClientAuthorizationProps,
    WithClientAuthorizationState
  > {
    state = { allowed: false };

    componentWillMount() {
      let user = this.props.user;
      let isTokenStillThere = serviceLocator.clientUserApi.isTokenStillThere();
      if (!isTokenStillThere) {
        user = undefined;
      }
      if (allowedRoles.length > 0) {
        if (UserHelper.isLoggedIn(user)) {
          this.setState({ allowed: true });
          this.props.addUser(user);
        } else {
          this.setState({ allowed: false });
          this.props.logOff();
        }
      } else {
        this.setState({ allowed: true });
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0);
    }

    render() {
      if (this.state.allowed) {
        return (
          <Fragment>
            {!hideHeader && <Header showPricing={showPricing} />}
            {!hideHeader && <div style={{ minHeight: '56px' }} />}
            <Suspense fallback={LayoutHelper.renderLoader()}>
              <ErrorBoundary>
                <WrappedComponent {...this.props} />
              </ErrorBoundary>
            </Suspense>
            {!hideFooter && <Footer />}
          </Fragment>
        );
      } else {
        return <div></div>;
      }
    }
  }

  const mapStateToProps = (state: AppState): StateProps => {
    const translate = getTranslate(state.locale);
    const currentLanguage = getActiveLanguage(state.locale).code;
    const domain = state.domain;

    return {
      user: state.user,
      t: translate,
      domain,
      currentLanguage,
    };
  };

  const mapDispatchToProps = (dispatch: any): DispatchProps => {
    return {
      addUser: (user: User) => {
        dispatch(addUser(user));
      },
      logOff: (location) => {
        let api = serviceLocator.userApi;
        api.killSession();
        dispatch(removeUser());
        if (location) {
          dispatch(
            push(
              `${routes.login()}?path=${location.pathname}${location.search}`
            )
          );
        } else if (redirectLogin) {
          dispatch(push(`${redirectLogin}`));
        } else {
          dispatch(push(`${routes.login()}`));
        }
      },
    };
  };
  return connect(mapStateToProps, mapDispatchToProps)(WithClientAuthorization);
};
